module.exports = __webpack_public_path__ + "img/performance-school-icon6.fb91d428.png";